import React, { useMemo } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import useBundleTranslation from 'i18n';
import { hide } from 'store/conciergeSlice';
import { useDispatch, useSelector } from 'react-redux';
import IconHandler from 'components/common/icon/IconHandler';

import { merge } from 'lodash';
import { ICustomStyles } from 'app/concierge/panel';
import defaultStyles from './styles';

export default function Header({
    activeTab,
    setActiveTab,
    setLastInteraction,
    botIcon,
}: {
    activeTab: string;
    setActiveTab: (tab: string) => void;
    setLastInteraction: (date: number) => void;
    botIcon?: string;
}) {
    const { t } = useBundleTranslation(['app/concierge/widget']);
    const dispatch = useDispatch();
    const conciergeSettings = useSelector((state: any) => state.auth?.configuration?.conciergeSettings) ?? {};
    const customStyles = useSelector((state: any) => state.concierge.customStyles) as ICustomStyles;

    const styles = useMemo(() => {
        return merge({}, defaultStyles, customStyles?.header) as typeof defaultStyles;
    }, [customStyles]);

    const conciergeIconProps = {
        type: botIcon ? 'upload' : conciergeSettings.bot_icon_ind,
        value: botIcon
            ? botIcon
            : conciergeSettings.bot_icon_ind === 'upload'
              ? `data:image/png;base64,${conciergeSettings.bot_icon_data}`
              : conciergeSettings.bot_icon_name,
    };

    const tabs = [
        { key: 'concierge', icon: conciergeIconProps },
        // postponed till 7.1.1
        //{ key: 'recent', icon: { type: 'mi', value: 'history' } },
    ];

    return (
        <Stack direction={'row'} sx={styles.container}>
            <Box>
                <Tabs
                    value={activeTab}
                    onChange={(event: React.SyntheticEvent, newValue: string) => {
                        setActiveTab(newValue);
                    }}
                    sx={{ mb: '-1px' }}
                >
                    {tabs.map((tab) => {
                        return (
                            <Tab
                                label={t(`header.tabs.${tab.key}`)}
                                key={tab.key}
                                value={tab.key}
                                icon={<IconHandler icon={tab.icon} fontSize={'16'} />}
                                iconPosition="start"
                            />
                        );
                    })}
                </Tabs>
            </Box>
            <Box>
                <Box
                    onClick={() => {
                        setLastInteraction(Date.now());
                        dispatch(hide());
                    }}
                    sx={styles.closeBtn}
                >
                    <IconMi icon="times" sx={{ fontSize: '16px' }} />
                </Box>
            </Box>
        </Stack>
    );
}
